import React from 'react';

import FirstHeader from '../components/firstHeader'
import Header from '../components/header'
import Fastbooking from '../components/fastbooking';
import Middlesection from '../components/middleSection'
import Footer from '../components/footer'
import SectionInformationBoxes from '../components/sectionInformationBoxes'

import SectionText from './sectionText'

const sectionText = () =>{
  return (
    <div className='route-section-text'>
      <FirstHeader />
      <Header isMenu={true} />

      <Fastbooking color='white'/>
      <Middlesection section='sectiontext' />
      <SectionText/>
      <SectionInformationBoxes/>

      <Footer />
    </div>
  )
}

export default sectionText;



// WEBPACK FOOTER //
// ./src/shared/routes/routeSectionText/index.js